import { Component, ViewChild, Input, Output,EventEmitter } from '@angular/core';
import { NavController, LoadingController, ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Broadcaster } from '../../app/broadcaster';
import { AlertController } from 'ionic-angular';
import { Response, Http, Headers, RequestOptions } from '@angular/http';
import { ApiService } from '../../app/services/api.service';
import { Config } from '../../app/app.config';
import { Localization } from '../../app/app.localization'
import { GmoPaymentComponent } from '../../components/gmo-payment/gmo-payment';
import { PaygentPaymentComponent } from '../../components/paygent-payment/paygent-payment';
import { OkagepayPaymentComponent } from '../../components/okagepay-payment/okagepay-payment';
import { CustomModalComponent } from '../../components/custom-modal/custom-modal';
import { OkageGoGoogleAnalyticsProvider } from '../../providers/okage-go-google-analytics/okage-go-google-analytics';
import { ConfirmOrderModalComponent } from '../../components/confirm-order-modal/confirm-order-modal';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage';

@Component({
  selector: 'page-send-order',
  templateUrl: 'send-order.html',
  providers: [ApiService]
})

export class SendOrderPage {

  @ViewChild('paymentForm') paymentForm: any;
  @ViewChild('paygentForm') paygentForm: any;
  @ViewChild('okagepayForm') okagepayForm: any;
  @ViewChild('mobileOrder') mobileOrder: any;
  menuArray: any = [];
  subArray = JSON.parse(this._okageStorage.getItem('foods.submenu'));
  subMst = JSON.parse(this._okageStorage.getItem('menuGroup.mst'));
  subSortMap = [];
  totalAmount = 0;
  totalQuantity = 0;
  loading: any;

  items: Array<Array<{ id: number, title: string, desc: string, thumb: string, price: number, notax_price: number, like: number; parent: number }>>;
  iCounter: Array<Array<number>>;
  iTotal: number;
  osentFlag: boolean;
  validTenkai: boolean;
  config: any;
  showOptions: boolean = false;
  chargeId: number;

  gmopayment: any;
  shopId: any;
  gmolink: any;

  paygentpayment: any;
  storeConfig: any;
  disableOption: boolean;

  okagepaypayment:any;

  quantityOption = [];
  leadTimeMin: number;

  @Input() service:any;
  @Output() returnEvent = new EventEmitter<any>();
  @Output() openOptions = new EventEmitter();
  @Output() hideOptions = new EventEmitter();
  showOption: boolean;
  hour: any;
  min: any;
  note: any;
  email: string = "";
  sms: string = "";
  error_msgs: string = '';
  preventSubmit: boolean;
  notificationType: any;
  receiveDates: any;
  receiveDate: Date;
  receiveTimes: any;
  receiveTime: string = "";
  enableEmail: boolean = false;
  enableSms: boolean = false;
  selectableEmail: boolean = false;
  selectableSms: boolean = false;
  requiredEmail: boolean = false;
  requiredSms: boolean = false;
  enableReceiveDate: boolean;
  enableReceiveTime: boolean;
  waitTime: number;
  paymentMethod: any;
  isShowPaymentArea: boolean;
  receiveTimesText: string = "";
  paymentModules: any;
  receiveMethod: string;
  deliveryNotificationType: any;
  deliveryEmail: string = "";
  deliverySms: string = "";
  name: string = "";
  postalCode: string = "";
  address: string = "";
  address2: string = "";
  waitTimeType: string = "";
  timeTitle: string = "";
  deliveryArea: string ="";
  deliveryAreaPostCode: any;
  orderList = [];
  requiredMenuList = (Config.build_as_takeout && this._okageStorage.getItem('requiredMenuList')) ? this._okageStorage.getItem('requiredMenuList') : [];
  deliveryCharge = (this._okageStorage.getItem('deliveryCharge')) ? this._okageStorage.getItem('deliveryCharge') : [];
  deliveryChargeStatus: any; // 0:注文不可 / 1:注文可能（配達料あり） / 2:注文可能（配達料なし）
  relationCode: string = "";
  description: string = "";
  enableRelationCode: boolean = false;
  requiredRelationCode: boolean = false;
  remarks: string = "";
  reserved_settings = (this._okageStorage.getItem('reserved_settings')) ? this._okageStorage.getItem('reserved_settings') : [];
  reserved_mode = (localStorage.getItem("reserved") == "1") ? true : false;
  reserved_datetime: any;
  reservedGuestName: string = "";
  duplicateOrderCheck: any;

  constructor(public navCtrl: NavController,
    private storage: Storage,
    private broadcaster: Broadcaster,
    private _loc: Localization,
    private alertCtrl: AlertController,
    private _apiService: ApiService,
    public http: Http,
    private _okageStorage: OkageStorageProvider,
    private loadingCtrl: LoadingController,
    private _ga: OkageGoGoogleAnalyticsProvider,
    private modalCtrl: ModalController)
    {
      this.storeConfig = JSON.parse(localStorage.getItem("configs"));
      this.config = Config;
      this.osentFlag = false;
      this.validTenkai = true;
      this.loading = this.loadingCtrl.create();
      this.items = [];
      this.disableOption = (this.storeConfig["MOBILEORDER_NOUSE_ADDRESS"] && parseInt(this.storeConfig["MOBILEORDER_NOUSE_ADDRESS"], 0) > 0);
      this.chargeId = this.storeConfig['MOBILEORDER_DELIVERY_CHARGE_MENU_ID'];
      this.duplicateOrderCheck = this.storeConfig['MOBILEORDER_DUPLICATE_ORDER_CHECK'] ? this.storeConfig['MOBILEORDER_DUPLICATE_ORDER_CHECK'] : [];
      this.storage.get('foods.menu').then((m) => {
        this.items = m;

        this.foodCounterChanged();
      });

      this.broadcaster.on<number>('foodCounterChanged')
        .subscribe(from => {
          if (from != 2) {
            this.foodCounterChanged();
          }
        });

      this.broadcaster.on<number>('submenuChanged')
        .subscribe(from => {
          if (from != 2) {
            this.subArray = JSON.parse(this._okageStorage.getItem('foods.submenu'));
            for (var mid in this.subArray) {
              this.subArray[mid].sort((a, b) => {
                if (parseInt(a.sort_order, 0) > parseInt(b.sort_order, 0)) return 1;
                if (parseInt(a.sort_order, 0) < parseInt(b.sort_order, 0)) return -1;
                if (parseInt(a.sort_order_in_group, 0) > parseInt(b.sort_order_in_group, 0)) return 1;
                if (parseInt(a.sort_order_in_group, 0) < parseInt(b.sort_order_in_group, 0)) return -1;
              });
            }
          }
        });
      /// mobile-order constructor
      if (this.config.build_as_takeout) {
        this.receiveTime = "";
        this.receiveTimes = [];
        this.receiveTimesText = "";
        this.showOption = false;
        this.hour = (localStorage.getItem("hour") != "null") ? localStorage.getItem("hour") : null;
        this.min = (localStorage.getItem("min") != "null") ? localStorage.getItem("min") : null;
        this.email = (localStorage.getItem("email") != "null") ? localStorage.getItem("email") : "";
        this.sms = (localStorage.getItem("sms") != "null") ? localStorage.getItem("sms") : "";
        this.deliveryEmail = (localStorage.getItem("email") != "null") ? localStorage.getItem("email") : "";
        this.deliverySms = (localStorage.getItem("sms") != "null") ? localStorage.getItem("sms") : "";
        this.note = (localStorage.getItem("note") != "null") ? localStorage.getItem("note") : null;
        this.name = (localStorage.getItem("name") != "null") ? localStorage.getItem("name") : null;
        this.postalCode = (localStorage.getItem("postalCode") != "null") ? localStorage.getItem("postalCode") : null;
        this.address = (localStorage.getItem("address") != "null") ? localStorage.getItem("address") : null;
        this.notificationType = (localStorage.getItem("notificationType") != "null") ? localStorage.getItem("notificationType") : null;
        this.preventSubmit = false;
        this.selectableEmail = (this.storeConfig["MOBILEORDER_ENABLE_EMAIL"] == "0") ? false : true;
        this.selectableSms = (this.storeConfig["MOBILEORDER_ENABLE_SMS"] == "0") ? false : true;
        let reservedFlg = localStorage.getItem('reserved') === "1" ? true : false;
        let remarks = (this.storeConfig["MOBILEORDER_REMARKS_BY_STORE"] && reservedFlg) ? (this.storeConfig["MOBILEORDER_REMARKS_BY_STORE"]) : "";
        if (remarks) this.remarks = remarks.split("\n");

        this.receiveMethod = localStorage.getItem('receiveMethod');
        if (this.storeConfig["MOBILEORDER_USER_INFO_TYPE"]) {
          let user_info_type = JSON.parse(this.storeConfig["MOBILEORDER_USER_INFO_TYPE"]).user_info_type;
          user_info_type = user_info_type.find(i => {
              if (i.receive_type === this.receiveMethod) {
                i.input_type.find(t => {
                  if (t.type === "sms") {
                    this.selectableSms = (t.select == "1");
                    this.enableSms = (t.enable == "1" || t.required == "1");
                    this.requiredSms = (t.required == "1");
                  }
                  if (t.type === "email") {
                    this.selectableEmail = (t.select == "1");
                    this.enableEmail = (t.enable == "1" || t.required == "1");
                    this.requiredEmail = (t.required == "1");
                  }
                  if (t.type === "relationCode" && reservedFlg) {
                    this.relationCode = localStorage.getItem("relation_code");
                    this.description = t.description;
                    this.enableRelationCode = (t.enable == "1" || t.required == "1");
                    this.requiredRelationCode = (t.required == "1");
                  }
              });
            }
          });
        }
        this.notificationType =
            (this.selectableEmail && !this.selectableSms) ? "email"
          : (!this.selectableEmail && this.selectableSms) ? "sms"
          : (localStorage.getItem("notificationType") == "email" && this.selectableEmail) ? "email"
          : (localStorage.getItem("notificationType") == "sms" && this.selectableSms) ? "sms"
          : ""; console.log("this.notificationType"); console.log(this.notificationType);
        if (this.receiveMethod === 'takeout') {
          // 通知方法の初期値：選択可能項目が一つの場合は強制選択、それ以外の場合はlocalStorageの値が有効の場合に選択させる
          this.waitTime = this.storeConfig["OKAGEGO_CURRENT_WAIT_MINUTES"];
          this.enableReceiveTime = (this.storeConfig["OKAGEGO_CURRENT_WAIT_MINUTES"] == "-1") ? false : true;
          this.waitTimeType = '待ち';
          this.timeTitle = this._loc.t('お受け取り希望時間');
        } else if (this.receiveMethod === 'delivery') {
          // 通知方法の初期値：選択可能項目が一つの場合は強制選択、それ以外の場合はlocalStorageの値が有効の場合に選択させる
          this.deliveryNotificationType = this.notificationType;
          this.waitTime = this.storeConfig["OKAGEGO_DELIVERY_WAIT_MINUTES"];
          this.enableReceiveTime = (this.storeConfig["OKAGEGO_DELIVERY_WAIT_MINUTES"] == "-1") ? false : true;
          this.waitTimeType = 'お届け';
          this.timeTitle = this._loc.t('お届け希望時間');
          this.deliveryArea = (this.storeConfig["MOBILEORDER_DELIVERY_AREA_TEXT"]) ? this.storeConfig["MOBILEORDER_DELIVERY_AREA_TEXT"] : "";
          this.deliveryAreaPostCode = (this.storeConfig["MOBILEORDER_DELIVERY_AREA_POST_CODE"]) ? JSON.parse(this.storeConfig["MOBILEORDER_DELIVERY_AREA_POST_CODE"]) : "";
        }
        if (this.reserved_mode) {
          this.waitTime = 0;
          this.enableReceiveDate = true;
          this.enableReceiveTime = true;
          this.timeTitle = this._loc.t('予約商品のお受け取り希望時間');
          this.receiveDates = this._okageStorage.getItem('reserved_dates');
          this.reservedGuestName = localStorage.getItem('guestName') ? localStorage.getItem('guestName') : '';
        }
      this.setReceiveTimes();
      this.setPaymentType();
    }
    if (this.receiveMethod != 'delivery' || !this.config.build_as_takeout) {
      this.deliveryCharge.enable = 0;
      this.deliveryChargeStatus = 0;
    }
    // 詳細画面の数量の選択肢を作成
    for (let i = 1; i < 100; i++) {
      this.quantityOption.push({
        count: i
      });
    }
    this.calculateTotalAmount();
  }

  ionViewDidEnter() {
    this.setReceiveTimes();
  }

  setReceiveTimes(initialize: boolean = false) {
    if (this.reserved_mode) return;
    let configWaitMinutes,
        configLeadTimeMin,
        configIntervalTimeMin,
        configLimitTimeHour,
        configLimitTimeMin,
        configTimeRule;

    if (this.receiveMethod === 'takeout') {
      configWaitMinutes = this.storeConfig["OKAGEGO_CURRENT_WAIT_MINUTES"];
      configLeadTimeMin = this.storeConfig["MOBILEORDER_LEAD_TIME_MIN"];
      configIntervalTimeMin = this.storeConfig["MOBILEORDER_INTERVAL_TIME_MIN"];
      configLimitTimeHour = this.storeConfig["MOBILEORDER_LIMIT_TIME_HOUR"];
      configLimitTimeMin = this.storeConfig["MOBILEORDER_LIMIT_TIME_MIN"];
      configTimeRule = this.storeConfig["MOBILEORDER_RECEIVE_TIMERULE"];
    } else {
      configWaitMinutes =　this.storeConfig["OKAGEGO_DELIVERY_WAIT_MINUTES"];
      configLeadTimeMin = this.storeConfig["MOBILEORDER_DELIVERY_LEAD_TIME_MIN"];
      configIntervalTimeMin = this.storeConfig["MOBILEORDER_DELIVERY_INTERVAL_TIME_MIN"];
      configLimitTimeHour = this.storeConfig["MOBILEORDER_DELIVERY_LIMIT_TIME_HOUR"];
      configLimitTimeMin = this.storeConfig["MOBILEORDER_DELIVERY_LIMIT_TIME_MIN"];
      configTimeRule = this.storeConfig["MOBILEORDER_DELIVERY_RECEIVE_TIMERULE"];
    }

    if (this.config.build_as_takeout) {
      this.receiveTimes = [];
      var now = new Date();

      var defaultLeadTimeMin = (configLeadTimeMin)
        ? parseInt(configLeadTimeMin)
        : 30;

      // 待ち時間 - DDSで待ち時間を設定した場合は（CURRENT_WAIT_MINUTES）を設定。その他はデフォルト(MOBILEORDER_LEAD_TIME_MIN)を指定する
      this.leadTimeMin = (configWaitMinutes && configWaitMinutes != "")
        ? parseInt(configWaitMinutes)
        : defaultLeadTimeMin;

      // 受取希望時間の間隔 - 設定値がない場合は30分で固定
      var intervalTimeMin = (configIntervalTimeMin && configWaitMinutes != "")
        ? parseInt(configIntervalTimeMin)
        : 30;

      // 受取希望時間の間隔最大時間 - 設定値がない場合は現在時間から2時間後
      var dtMax = (configLimitTimeHour && configLimitTimeHour != ""
                  && configLimitTimeMin && configLimitTimeMin != "")
        ? new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(configLimitTimeHour), parseInt(configLimitTimeMin))
        : new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + 240);

      var minute = Math.floor((now.getMinutes() + this.leadTimeMin) / intervalTimeMin) * intervalTimeMin; // ((現在の分+リードタイム)➗繰り返し時間単位)✖️繰り返し時間単位
      var dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), minute + intervalTimeMin);

      // 受取時間間隔が5分未満だったら、受取時間設定の最短時間を5分にする
      if(this.leadTimeMin < 5 && intervalTimeMin < 5 ){
        dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), minute + 5);
      }

      // 時間ルール - 注文する時間に合わせて受取希望時間を設定。 （例: [注文時間(order)：10:00~12:00] [受取希望時間(limit):10:30~13:00] / [注文時間(order)：16:00~18:00] [受取希望時間(limit):16:00~19:00])
      var receiveTimeRule = (configTimeRule) ? JSON.parse(configTimeRule) : "";
      if (receiveTimeRule != "" && receiveTimeRule.rules) {
        var limitFrom: Date;
        var limitTo: Date;
        for (let i = 0; i < receiveTimeRule.rules.length; i++) {
          var rule = receiveTimeRule.rules[i];
          var orderFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate(), rule.order.from.substr(0,2), rule.order.from.substr(3,2));
          var orderTo = new Date(now.getFullYear(), now.getMonth(), now.getDate(), rule.order.to.substr(0,2), rule.order.to.substr(3,2));
          // 時間ルールに現在の時間で注文可能な時間がある場合
          if (orderFrom.getTime() <= now.getTime() && now.getTime() <= orderTo.getTime()) {
            limitFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate(), rule.limit.from.substr(0,2), rule.limit.from.substr(3,2));
            limitTo = new Date(now.getFullYear(), now.getMonth(), now.getDate(), rule.limit.to.substr(0,2), rule.limit.to.substr(3,2));
            while (limitFrom.getTime() <= limitTo.getTime()) {
              if (dt.getTime() <= limitFrom.getTime()) {
                this.receiveTimes.push({
                  hour: (("0") + limitFrom.getHours()).substr(-2),
                  min: (("0") + limitFrom.getMinutes()).substr(-2)
                });
              }
              limitFrom = new Date(limitFrom.getFullYear(), limitFrom.getMonth(), limitFrom.getDate(), limitFrom.getHours(), limitFrom.getMinutes() + intervalTimeMin);
            }
            break;
          }
          // 時間ルールに現在以降の時間で注文可能な時間がある場合
          if (now.getTime() < orderFrom.getTime() && now.getTime() < orderTo.getTime()) {
            this.receiveTimesText = "現在、注文できません。次回の注文開始時間("+rule.order.from+")";
            break;
          }
        }
      } else {
        var i = 0;
        while (dt.getTime() <= dtMax.getTime()) {
          this.receiveTimes.push({
              hour: (("0") + dt.getHours()).substr(-2),
              min: (("0") + dt.getMinutes()).substr(-2)
          });
          dt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes() + intervalTimeMin);
          if (i > 100 || dt.getTime() > dtMax.getTime()) break;
          i++;
        }
      }
      if (this.receiveTimes.length == 0 && this.receiveTimesText.length == 0) {
        this.receiveTimesText = "本日の受付は終了しております。";
      }
      this.receiveTime = (this.receiveTimes.length > 0 && (initialize || this.receiveTime == "")) ? this.receiveTimes[0].hour + ":" + this.receiveTimes[0].min : this.receiveTime;
    }
  }

  saveMobileOrderOption() {
    let isTakeout = this.receiveMethod === 'takeout';

    if (this.config.build_as_takeout) {
      if (!this.enableReceiveTime) {
        this.setReceiveTimes(false);
      }
      let selectEmail,
          selectSms,
          selectNotificationType;
      if (isTakeout) {
        selectEmail = this.email;
        selectSms = this.sms;
        selectNotificationType = this.notificationType;
      } else {
        selectEmail = this.deliveryEmail;
        selectSms = this.deliverySms;
        selectNotificationType = this.deliveryNotificationType;
      }

      localStorage.setItem("hour", this.receiveTime.substr(0,2));
      localStorage.setItem("min", this.receiveTime.substr(3,2));
      localStorage.setItem("email", selectEmail);
      localStorage.setItem("sms", selectSms);
      localStorage.setItem("name", this.name);
      localStorage.setItem("postalCode", this.postalCode);
      localStorage.setItem("address", this.address);
      localStorage.setItem("note", this.note);
      localStorage.setItem("notificationType", (this.selectableEmail || this.selectableSms) ? selectNotificationType : "none");
      localStorage.setItem("paymentType", this.paymentMethod);
      localStorage.setItem("guestId", this.relationCode ? this.relationCode : "");
      localStorage.setItem("guestDescription", this.description ? this.description : "");
      localStorage.setItem("guestName", this.reserved_mode ? this.reservedGuestName : "");
    }
  }

  priceString(price) {
    var newPrice;
    newPrice = String(price).split('.');
    newPrice[0] = newPrice[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return newPrice.join('.');
  }

  deliveryChargeString() {
    switch (this.deliveryChargeStatus) {
      case 0 : // 最低注文金額以下
        return "最低注文金額 ¥"+this.priceString(this.deliveryCharge.min_order_price)+"以上ご注文ください";
      case 1 : // 最低注文金額以上、配達料無料以下
        return "¥ "+this.priceString(this.deliveryCharge.charge_menu.price);
      case 2 : // 配達料無料以上
        return "無料";
      default :
        break;
    }
  }

  deliveryAreaInfo() {
    var modalSubTitle = [];
    if (this.deliveryAreaPostCode.info) {
      modalSubTitle.push(this.deliveryAreaPostCode.info);
    }
    modalSubTitle.push('■ '+this._loc.t('配達可能エリア郵便番号'));
    this.deliveryAreaPostCode.delivery_area_post_code.forEach(postCode => {
      modalSubTitle.push('・'+postCode);
    });
    const modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('配達可能エリア'), subTitles: modalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
    modal.present();
  }

  ionViewWillEnter() {
    this._ga.sendOrderPageView();
    // this.validTenkai = this.validateTenkaiMenu();
    this.validTenkai = true;
  }

  foodCounterChanged() {
    this.orderList = JSON.parse(localStorage.getItem('orderList'));

    this.calculateTotalAmount();
  }

  clickMobileOrder() {
    if (this.disableOption) {
      this.clickToPayment();
      return;
    }
    if (this.mobileOrder.validateOptions()) {
      this.clickToPayment();
      return;
    }

    let modal = this.modalCtrl.create(CustomModalComponent, { title: '', subTitle: this.mobileOrder.getValidateError(), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
    modal.present();
  }

  searchFromSubMst(menu_id, sub_menu_id) {
    if (this.subSortMap.length < 1) {
      this.subSortMap = [];
      for (let i = 0; i < this.subMst.length; i++) {
        this.subSortMap[this.subMst[i].menu_id + "_" + this.subMst[i].sub_menu_id] = this.subMst[i].sort_order;
      }
    }
    if (this.subSortMap[menu_id + "_" + sub_menu_id]) {
      return this.subSortMap[menu_id + "_" + sub_menu_id];
    }
    return -1;
  }

  checkDeliveryChargeStatus() {
    if (this.deliveryCharge) {
      if (this.totalAmount < this.deliveryCharge.min_order_price) {
        this.deliveryChargeStatus = 0;
        this.preventSubmit = false;
      }
      if (this.deliveryCharge.min_order_price <= this.totalAmount && this.totalAmount < this.deliveryCharge.chargefree_order_price) {
        this.deliveryChargeStatus = 1;
      }
      if (this.deliveryCharge.chargefree_order_price <= this.totalAmount) {
        this.deliveryChargeStatus = 2;
      }
    }
  }

  checkPostCode(postCode) {
    if (!postCode) {
      return this._loc.t('・'+'郵便番号を入力してください');
    }
    if (!this.postalCode.match(/^[0-9\-]+$/)) {
      return this._loc.t('・'+'郵便番号は半角数字で入力してください');
    }
    if (!this.postalCode.match(/^\d{3}[-]?\d{4}$/)) {
      return this._loc.t('・'+'郵便番号は7桁で入力してください');
    }
    if (this.deliveryAreaPostCode.delivery_area_post_code) {
      if (this.deliveryAreaPostCode.delivery_area_post_code.indexOf(postCode) == -1) {
        this.address2 = "配達可能エリアではありません";
        return this._loc.t('・'+'配達可能エリアを入力してください');
      } else {
        this.address2 = "";
      }
    }
    return "";
  }

  calculateTotalAmount() {
    console.log("calculateTotalAmount");
    this.totalAmount = 0;
    this.totalQuantity = 0;
    this.requiredMenuList.forEach(r_menus => {
      if (r_menus.selected_menu) this.totalAmount += (r_menus.selected_menu.price * 1);
    })
    this.orderList.forEach(element => {
      this.totalAmount += (element.quantity * element.price);
      this.totalQuantity += element.quantity;
      if (element.sub) {
        element.sub.forEach(subElement => {
          this.totalAmount += (element.quantity * subElement.quantity * subElement.price);
        });
      }
    });

    this.preventSubmit = true;
    if (this.config.build_as_takeout) {
      if (this.receiveMethod === 'takeout') this.validateTakeoutInput();
      if (this.receiveMethod === 'delivery') {
        this.checkDeliveryChargeStatus();
        if (this.deliveryChargeStatus === 1) {
          this.totalAmount += (this.deliveryCharge.charge_menu.price * 1);
        }
        this.validateDeliveryInput();
      }
    }
    if (this.totalQuantity < 1) this.preventSubmit = false;
  }

  calculateMenuTotalAmount(menu) {
    var menuTotalAmount: number = (menu.price * menu.quantity);
    if (menu.sub) {
      menu.sub.forEach(sub => {
        menuTotalAmount += (menu.quantity * sub.quantity * sub.price);
      });
    }
    return this.priceString(menuTotalAmount);
  }

  // 支払い方法の取得
  setPaymentType() {
    let configPaymentModule = this.storeConfig['MOBILEORDER_PAYMENT_MODULE'];
    let paymentModule = [];

    // jsonで受け取った値の場合はobject型に変換する
    if (configPaymentModule != undefined && configPaymentModule && configPaymentModule.includes('payment_modules')) {
      let jsonPaymentModule = JSON.parse(configPaymentModule);
      this.isShowPaymentArea = true;

      jsonPaymentModule.payment_modules.map(function(value, index, array) {
        // display_buttonの値がない場合
        if (value['display_button'] === '' && value['type'] === 'nopayment') {
          value['display_button'] = 'お店で支払う'
        } else if (value['display_button'] === '' && value['type'] !== 'nopayment') {
          value['display_button'] = '後で支払う'
        }
        paymentModule.push(array[index]);
      })
      this.paymentModules = paymentModule;
      // 他でも支払い方法が選択出来るようにストレージに保存
      localStorage.setItem("enablePaymentModules", JSON.stringify(paymentModule));
    } else {
      this.isShowPaymentArea = false;
      // 複数選択出来ない場合は、configの値を選択した状態にする
      this.paymentMethod = configPaymentModule;
      localStorage.setItem("enablePaymentModules", JSON.stringify({payment_modules:[{type:this.paymentMethod}]}));
    }
  }

  countDecimals(number) {
    var str = "" + number;
    var index = str.indexOf('.');
    if (index >= 0) {
      return str.length - index - 1;
    } else {
      return 0;
    }
  }

  updateQuantity(orderListNum, quantity) {
    for (var i = 0; i < this.orderList.length; i++) {
      if (this.orderList[i].orderListNum == orderListNum) {
        this.orderList[i].quantity = parseInt(quantity);
      }
    }
    //this.orderList[orderListNum].quantity = parseInt(quantity);
    localStorage.setItem("orderList", JSON.stringify(this.orderList));
    this.storage.set('foods.selected', this.iCounter).then((v) => {
      this.broadcaster.broadcast('foodCounterChanged', 2);
      this._okageStorage.setItem('foods.submenu', JSON.stringify(this.subArray));
      this.broadcaster.broadcast('submenuChanged', 2);
      this.calculateTotalAmount();
    });

  }

  clickDelete(menu) {
    this.orderList = this.orderList.filter(order => order.orderListNum !=  menu.orderListNum);
    localStorage.setItem("orderList", JSON.stringify(this.orderList));
    this.storage.set('foods.selected', this.iCounter).then((v) => {
      this.broadcaster.broadcast('foodCounterChanged', 2);
      this._okageStorage.setItem('foods.submenu', JSON.stringify(this.subArray));
      this.broadcaster.broadcast('submenuChanged', 2);
      this.calculateTotalAmount();
    });
  }
  clickDeleteAll() {
    this.orderList = [];
    localStorage.setItem("orderList", JSON.stringify(""));
    this.storage.set('foods.selected', this.iCounter).then((v) => {
      this.broadcaster.broadcast('foodCounterChanged', 2);
      this.calculateTotalAmount();
      localStorage.setItem("clickReturnToTop", "true");
      let conf = JSON.parse(localStorage.getItem("configs"));
      if (conf["MOBILEORDER_FIXED_LAYOUT"] && parseInt(conf["MOBILEORDER_FIXED_LAYOUT"]) > 0){
        this.navCtrl.parent.select(Config.tab_menu_number.menulistpage);
      }else{
        this.navCtrl.parent.select(Config.tab_menu_number.menulayoutspage);
      }
    });
  }

  clickDerease(menu) {
    if (!this.iCounter[menu.aIndex][menu.iIndex]) {
      return;
    }

    this.menuArray.forEach(element => {
      if (element.id == menu.id) {
        if (element.quantity > 0) {
          element.quantity -= 1;
        }
      }
    });

    this.iCounter[menu.aIndex][menu.iIndex]--;
    this.storage.set('foods.selected', this.iCounter).then((v) => {
      this.broadcaster.broadcast('foodCounterChanged', 2);
    });

    this.calculateTotalAmount();
    this.validTenkai = this.validateTenkaiMenu();
  }

  clickIncrease(menu) {
    this.menuArray.forEach(element => {
      if (element.id == menu.id) {
        element.quantity += 1;
      }
    });

    this.iCounter[menu.aIndex][menu.iIndex]++;
    this.storage.set('foods.selected', this.iCounter).then((v) => {
      this.broadcaster.broadcast('foodCounterChanged', 2);
    });

    this.calculateTotalAmount();
    this.validTenkai = this.validateTenkaiMenu();
  }

  clicksubDescrease(menuid, subindex) {
    if (!this.subArray[menuid][subindex]) {
      return;
    }
    if (this.subArray[menuid][subindex].quantity <= 0) {
      return;
    }
    this.subArray[menuid][subindex].quantity--;

    this.calculateTotalAmount();

    this._okageStorage.setItem('foods.submenu', JSON.stringify(this.subArray));
    this.broadcaster.broadcast('submenuChanged', 2);
    /*
    if (this.subArray[menuid][subindex].required) {
        this.updateMenuQuantity(menuid);
    }
    */
    this.validTenkai = this.validateTenkaiMenu();
  }

  clicksubIncrease(menuid, subindex) {
    this.subArray[menuid][subindex].quantity++;

    this.calculateTotalAmount();
    this._okageStorage.setItem('foods.submenu', JSON.stringify(this.subArray));
    this.broadcaster.broadcast('submenuChanged', 2);
    this.validTenkai = this.validateTenkaiMenu();
  }


  validateTenkaiMenu(withAlert = false) {
    if (this.totalQuantity < 1) {
      let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('注文するには少なくとも\n1つのアイテムを選択してください'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.present();
      return false;
    }
    if (this.menuArray.length > 0) {
      for (let k = 0; k < this.menuArray.length; k++) {
        if (typeof this.menuArray[k].sub !== 'undefined') {
          if (this.menuArray[k].sub.length > 0) {
            let hasSubQty = false;
            let gmenus: any = {};
            for (let i = 0; i < this.subArray[this.menuArray[k].id].length; i++) {
              if (this.subArray[this.menuArray[k].id][i].quantity > 0) {
                hasSubQty = true;
              }
              if (this.subArray[this.menuArray[k].id][i].required == true && typeof this.subArray[this.menuArray[k].id][i].group_name !== 'undefined') {
                if (!gmenus[this.subArray[this.menuArray[k].id][i].group_name]) {
                  gmenus[this.subArray[this.menuArray[k].id][i].group_name] = [];
                }
                gmenus[this.subArray[this.menuArray[k].id][i].group_name].push(this.subArray[this.menuArray[k].id][i]);
              }
            }

            let icount = null;
            if (typeof this.iCounter[this.menuArray[k].aIndex] !== 'undefined'
              && typeof this.iCounter[this.menuArray[k].aIndex][this.menuArray[k].iIndex] !== 'undefined') {
              icount = this.iCounter[this.menuArray[k].aIndex][this.menuArray[k].iIndex];
            }

            if (hasSubQty && !icount) {
              if (withAlert) {
                let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('数量が入力されていません。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                modal.present();
              }
              return false;
            }

            if (icount) {
              if (Object.keys(gmenus).length !== 0) {
                let emsg = '';
                for (let menu in gmenus) {
                  let qty = 0;
                  for (let j = 0; j < gmenus[menu].length; j++) {
                    qty += gmenus[menu][j].quantity;
                  }
                  if (this.iCounter[this.menuArray[k].aIndex][this.menuArray[k].iIndex] != qty) {
                    console.log(this.iCounter[this.menuArray[k].aIndex][this.menuArray[k].iIndex]);
                    console.log(qty);
                    emsg += 'サブメニューグループ' + menu + '、';
                  }
                }
                if (emsg !== '') {
                  emsg = emsg.substring(0, emsg.length - 1);
                  if (withAlert) {
                    let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: emsg + this._loc.t('の数量があいません。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                    modal.present();
                  }
                  return false;
                }
              }
            }
          }
        }
      }
    }
    return true;
  }

  clickMenu() {
    this.saveMobileOrderOption();
    let conf = JSON.parse(localStorage.getItem("configs"));
    if (conf["MOBILEORDER_FIXED_LAYOUT"] && parseInt(conf["MOBILEORDER_FIXED_LAYOUT"]) > 0) {
      this.navCtrl.parent.select(Config.tab_menu_number.menulistpage);
    } else {
      this.navCtrl.parent.select(Config.tab_menu_number.menulayoutspage);
    }
  }

  validateBeforeSend() {
    if (!this.validTenkai) {
      return false;
    }
    this.osentFlag = true;
    let eid = localStorage.getItem('employee_id');
    if (!eid) eid = "1";
    if (!eid) {
      let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('サーバーへの接続に問題が発生しています。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
      this.osentFlag = false;
      modal.present();
      return false;
    }
    return eid;
  }

  makeOrderData(eid, visitor_id = 0, table_id = 0){
      if (visitor_id < 1) visitor_id = parseInt(localStorage.getItem("visitor_id"), 0);
      if (table_id < 1) table_id = Config.table_id;
      let ojson = {
          employee_id: eid,
          orders: [],
          uiid: Config.uiid
      };

      var seq_no = -1;
      for(var i = 0; i < this.menuArray.length; i++) {
          if (this.menuArray[i].quantity > 0) {
              seq_no++;
              ojson.orders.push({
                  remarks: "OkageGo",
                  quantity: this.menuArray[i].quantity,
                  table_id: table_id,
                  origin_quantity: this.menuArray[i].quantity,
                  store_id: localStorage.getItem("store_id"),
                  visitor_id: visitor_id,
                  especial_price: this.menuArray[i].price,
                  original_especial_price: this.menuArray[i].price,
                  include_tax_price: this.menuArray[i].notax_price,
                  seq_no: seq_no,
                  menu: {
                      menu_id: this.menuArray[i].id
                  },
                  menu_id: this.menuArray[i].id
              });

              if (this.menuArray[i].sub) {
                  this.menuArray[i].sub.forEach(esub => {
                      if (esub.quantity > 0) {
                          ojson.orders.push({
                              remarks: "OkageGo",
                              quantity: esub.quantity,
                              parent_menu_id: esub.parent,
                              table_id: table_id,
                              origin_quantity: esub.quantity,
                              especial_price: esub.price,
                              original_especial_price: esub.price,
                              include_tax_price: esub.notax_price,
                              seq_no: seq_no,
                              store_id: localStorage.getItem("store_id"),
                              visitor_id: visitor_id,
                              menu: {
                                  menu_id: esub.id
                              },
                              menu_id: esub.id
                          });
                      }
                  });
              }
          }
      }
    return ojson;
  }

  checkVisitorAndSendOrder() {
    let table_id = parseInt(localStorage.getItem("table_id"), 0);
    if (!table_id || table_id < 1) {
      let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('システムエラー'), subTitle: this._loc.t('エラーが発生しました。\n:missing table_id. need realod url'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.present();
      return;
    }
    this.clickSendOrder();
  }
  clickSendOrder(visitor_id = 0) {
    if (!this.validateTenkaiMenu(true)) {
      return;
    }

    let eid = this.validateBeforeSend();
    if (!eid) return;

    let ojson = this.makeOrderData(eid, 0, parseInt(localStorage.getItem("table_id"), 0));
    ojson.orders = this.makeOrderList();
    console.log(ojson);

    this.loading = this.loadingCtrl.create();
    this.loading.present();

    this._apiService.order(ojson).subscribe(
      (result) => {
        console.log(result);
        this.storage.set('order.lres', result);
        if (typeof result.result !== 'undefined') {
          let cojson = {
            order_no: result.order_no,
            visitor_id: localStorage.getItem("visitor_id"),
            uiid: Config.uiid,
            store_id: localStorage.getItem("store_id")
          };

          this._apiService.commitOrder(cojson).subscribe(
            (reso) => {
              this.loading.dismiss();
              this.storage.set('corder.lres', reso);
              if (reso.status == 1000) {
                  let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文を承りました'), subTitle: this._loc.t('ありがとうございました。\nしばらくお待ちください。'), bottomButton: this._loc.t('はい') }, { showBackdrop: false, enableBackdropDismiss: false });
                  modal.present();
                  this.clickDeleteAll();
              } else if (reso.result == 1001) {
                // duplicate request
                return;
              } else {
                let errorMessage = this._loc.t('サーバーへの接続に問題が発生しています。');
                if (reso.error_message && reso.error_message.length > 0) errorMessage = reso.error_message;
                let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: errorMessage, bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                this.osentFlag = false;
                modal.present();
                return;
              }
            }, (error) => {
              this.osentFlag = false;
              console.log(error);
              this.loading.dismiss();
            }
          );
        } else {
          let errorMessage = this._loc.t('サーバーへの接続に問題が発生しています。');
          if (result.error_message && result.error_message.length > 0) {
            errorMessage = result.error_message;
          }
          let alert = null;
          let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: errorMessage, bottomButton: this._loc.t('OK'), redirect:result.need_reload }, { showBackdrop: false, enableBackdropDismiss: false });
          modal.present();
          this.osentFlag = false;
          this.loading.dismiss();
        }
      }, (error) => {
        console.log(error);
        this.osentFlag = false;
        let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('サーバーへの接続に問題が発生しています。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
        modal.present();
        this.loading.dismiss();
      });
  }

  mailCheck( mail ) {
    if( mail.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        return true;
    } else {
        return false;
    }
  }

  telCheck(telNo) {
    // 半角数字で
    // 先頭0で
    // 10桁または11桁じゃない場合はエラー
    if (telNo === null || telNo.length === 0 || telNo.match(/[^0-9]+/)) return false;
    if (!telNo.match(/^0\d{9,10}$/)) return false;
    return true;
  }

  relationCodeCheck(code) {
    if ((code !== null && code.length > 0)  && !code.match(/^[0-9]{12}$/)) return false;
    return true;
  }

  validateReservedInput(showErrorMessage: boolean = false) {
    var modalSubTitle = [];
    if ((!this.reserved_datetime)) {
      modalSubTitle.push('・'+this._loc.t('お届け希望時間を選択してください'));
    }
    if (this.selectableEmail || this.selectableSms) {
      if (this.deliveryNotificationType != "sms" && this.deliveryNotificationType != "email") {
        modalSubTitle.push(this._loc.t('・'+'通知の受け取り方法を選択してください'));
      }
    }
    if (this.deliveryEmail === "") {
      modalSubTitle.push(this._loc.t('・'+'メールアドレスを入力してください'));
    } else if (this.deliveryEmail != "" && !this.mailCheck(this.deliveryEmail)) {
      modalSubTitle.push(this._loc.t('・'+'メールアドレスは半角英数字・記号で入力してください'));
    }
    if (this.deliverySms === "") {
      modalSubTitle.push(this._loc.t('・'+'電話番号を入力してください'));
    }
    if (this.name === "") {
      modalSubTitle.push(this._loc.t('・'+'お名前を入力してください'));
    }
    var checkPostCodeResult = this.checkPostCode(this.postalCode);
    if (checkPostCodeResult !== "") {
      modalSubTitle.push(checkPostCodeResult);
    }
    if (!this.address) {
      modalSubTitle.push(this._loc.t('・'+'住所を入力してください'));
    }
    if ((this.requiredRelationCode && !this.relationCode)) {
      modalSubTitle.push(this._loc.t('・'+'アプリ会員IDを入力してください'));
    }
    // 必須メニューが存在し、選択されていない場合
    this.requiredMenuList.forEach(r_menus => {
      if (r_menus.selected_menu == null) modalSubTitle.push('・'+r_menus.required_name+'を選択してください');
    });
    if (this.isShowPaymentArea && !this.paymentMethod && this.totalAmount > 0) {
      modalSubTitle.push(this._loc.t('・'+'お支払い方法を選択してください'));
    }
    if (this.deliveryCharge && this.deliveryChargeStatus === 0) {
      modalSubTitle.push(this._loc.t('・配達注文の最低注文金額\n　¥'+this.priceString(this.deliveryCharge.min_order_price)+'以上ご注文してください'));
    }

    var validateResult = (modalSubTitle.length == 0) ? true : false;
    if (showErrorMessage && !validateResult) {
      const modal = this.modalCtrl.create(ConfirmOrderModalComponent, { title: this._loc.t('必須項目を入力してください'), subTitles: modalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.present();
    }
    this.preventSubmit = validateResult;
    return validateResult;
  }

  validateDeliveryInput(showErrorMessage: boolean = false) {
    var modalSubTitle = [];
    if ((this.enableReceiveTime && !this.receiveTime) || (this.receiveTime && this.receiveTime == "")) {
      modalSubTitle.push('・'+this._loc.t('お届け希望時間を選択してください'));
    }

    if (this.selectableEmail || this.selectableSms) {
      if (this.deliveryNotificationType != "sms" && this.deliveryNotificationType != "email") {
        modalSubTitle.push(this._loc.t('・'+'通知の受け取り方法を選択してください'));
      }
    }
    if (this.deliveryEmail === "") {
      modalSubTitle.push(this._loc.t('・'+'メールアドレスを入力してください'));
    } else if (this.deliveryEmail != "" && !this.mailCheck(this.deliveryEmail)) {
      modalSubTitle.push(this._loc.t('・'+'メールアドレスは半角英数字・記号で入力してください'));
    }
    if (this.deliverySms === "") {
      modalSubTitle.push(this._loc.t('・'+'電話番号を入力してください'));
    } else if (this.deliverySms !== "" && !this.telCheck(this.deliverySms)) {
      modalSubTitle.push(this._loc.t('・'+'電話番号は半角数字(ハイフン無し)で入力してください'))
    }
    if (this.name === "") {
      modalSubTitle.push(this._loc.t('・'+'お名前を入力してください'));
    }
    var checkPostCodeResult = this.checkPostCode(this.postalCode);
    if (checkPostCodeResult !== "") {
      modalSubTitle.push(checkPostCodeResult);
    }
    if (!this.address) {
      modalSubTitle.push(this._loc.t('・'+'住所を入力してください'));
    }
    // 必須メニューが存在し、選択されていない場合
    this.requiredMenuList.forEach(r_menus => {
      if (r_menus.selected_menu == null) modalSubTitle.push('・'+r_menus.required_name+'を選択してください');
    });
    if ((this.requiredRelationCode && this.relationCode == '')) {
      modalSubTitle.push(this._loc.t('・'+'アプリ会員IDを入力してください'));
    }
    if (this.relationCode != '' && !this.relationCodeCheck(this.relationCode)) {
      modalSubTitle.push(this._loc.t('.'+'アプリ会員IDは12桁の半角数字で入力してください'));
    }
    if (this.isShowPaymentArea && !this.paymentMethod && this.totalAmount > 0) {
      modalSubTitle.push(this._loc.t('・'+'お支払い方法を選択してください'));
    }
    if (this.deliveryCharge && this.deliveryChargeStatus === 0) {
      modalSubTitle.push(this._loc.t('・配達注文の最低注文金額\n　¥'+this.priceString(this.deliveryCharge.min_order_price)+'以上ご注文してください'));
    }

    var validateResult = (modalSubTitle.length == 0) ? true : false;
    if (showErrorMessage && !validateResult) {
      const modal = this.modalCtrl.create(ConfirmOrderModalComponent, { title: this._loc.t('必須項目を入力してください'), subTitles: modalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.present();
    }
    this.preventSubmit = validateResult;
    return validateResult;
  }

  validateTakeoutInput(showErrorMessage: boolean = false) {
    var modalSubTitle = [];
    if ((this.enableReceiveDate && !this.receiveDate) || (this.receiveDate && this.receiveDate == null)) {
      modalSubTitle.push('・'+this._loc.t('受け取り日付を選択してください'));
    }
    if ((this.enableReceiveTime && !this.receiveTime) || (this.receiveTime && this.receiveTime == "")) {
      modalSubTitle.push('・'+this._loc.t('受け取り時間を選択してください'));
    }
    let regSymbol = new RegExp(/[!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]/g);
    if (this.reserved_mode && this.reservedGuestName == "") {
      modalSubTitle.push(this._loc.t('・'+'お名前を入力してください'));
    } else if (this.reservedGuestName && this.reservedGuestName.length > 50) {
      modalSubTitle.push(this._loc.t('・'+'お名前は50文字以内で入力してください'));
    } else if (regSymbol.test(this.reservedGuestName)) {
      modalSubTitle.push(this._loc.t('・'+'お名前に記号は使用出来ません'));
    }
    if (this.selectableEmail || this.selectableSms) {
      if (this.notificationType != "sms" && this.notificationType != "email") {
        modalSubTitle.push(this._loc.t('・'+'通知の受け取り方法を選択してください'));
      }
      if ((this.notificationType == "sms" || this.requiredSms) && (!this.sms || this.sms.length == 0)) {
        modalSubTitle.push(this._loc.t('・'+'電話番号を入力してください'));
      }
      if ((this.notificationType == "sms" || this.requiredSms) && (!this.sms || this.sms.length > 0) && !this.telCheck(this.sms)) {
        modalSubTitle.push(this._loc.t('・'+'電話番号は半角数字(ハイフン無し)で入力してください'));
      }
      if ((this.notificationType == "email" || this.requiredEmail) && (!this.email || this.email.length == 0)) {
        modalSubTitle.push(this._loc.t('・'+'メールアドレスを入力してください'));
      }
      if ((this.notificationType == "email" || this.requiredEmail) && (this.email && this.email.length > 0)) {
        if(!this.mailCheck(this.email)) {
          modalSubTitle.push(this._loc.t('・'+'メールアドレスは半角英数字・記号で入力してください'));
        }
      }
      // 必須メニューが存在し、選択されていない場合
      this.requiredMenuList.forEach(r_menus => {
        if (r_menus.selected_menu == null) modalSubTitle.push('・'+r_menus.required_name+'を選択してください');
      });
    }
    if ((this.requiredRelationCode && this.relationCode == '')) {
      modalSubTitle.push(this._loc.t('・'+'アプリ会員IDを入力してください'));
    }
    if (this.relationCode != '' && !this.relationCodeCheck(this.relationCode)) {
      modalSubTitle.push(this._loc.t('・'+'アプリ会員IDは12桁の半角数字で入力してください'));
    }
    if (this.isShowPaymentArea && !this.paymentMethod && this.totalAmount > 0) {
      modalSubTitle.push(this._loc.t('・'+'お支払い方法を選択してください'));
    }
    var validateResult = (modalSubTitle.length == 0) ? true : false;
    if (showErrorMessage && !validateResult) {
      const modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('必須項目を入力してください'), subTitles: modalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.present();
    }
    this.preventSubmit = validateResult;
    return validateResult;
  }

  validateTakeoutRange() {
    if (this.enableReceiveTime && this.receiveTime == "") {
      var limitTime = new Date(2020, 1, 1, new Date().getHours(), new Date().getMinutes() + this.leadTimeMin);
      var validateTime = new Date(2020, 1, 1, Number(this.receiveTime.substr(0,2)), Number(this.receiveTime.substr(3,2)));
      if (limitTime > validateTime) {
        this.setReceiveTimes(true);
        const modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('希望時間が\n過ぎています'), subTitle: this._loc.t('申し訳ございませんが、\n希望時間を再設定してください。'), bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
        modal.present();
        return false;
      }
    }
    return true;
  }

  clickToPayment() {
    if (this.totalAmount == 0) {
      this.paymentMethod = 'nopayment';
    }
    this.saveMobileOrderOption()
    if (!this.validateTenkaiMenu(true)) {
      return;
    }

    if (this.config.build_as_takeout) {
      let isTakeoutMethod = (this.receiveMethod === 'takeout');
      if (isTakeoutMethod && !this.validateTakeoutInput(true)) {
        return;
      }
      if (isTakeoutMethod && !this.validateTakeoutRange()) {
        return;
      }
      if(!isTakeoutMethod && !this.validateDeliveryInput(true)) {
        return;
      }
      var newPrice;
      newPrice = String(this.totalAmount).split('.');
      newPrice[0] = newPrice[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      newPrice.join('.');

      var modalSubTitle = [];

      if (isTakeoutMethod) {
        if (this.enableReceiveDate) {
          modalSubTitle.push(this._loc.t('受け取り日')+':'+this.formatDate(this.receiveDate));
        }
        if (this.enableReceiveTime) {
          modalSubTitle.push(this._loc.t('受け取り時間')+':'+this.receiveTime);
        }
        if (this.selectableSms && this.notificationType == "sms") {
          modalSubTitle.push(this._loc.t('通知先')+':'+this.sms);
        }
        if (this.selectableEmail && this.notificationType == "email") {
          modalSubTitle.push(this._loc.t('通知先')+':'+this.email);
        }
      } else {
        if (this.enableReceiveDate) {
          modalSubTitle.push(this._loc.t('お届け希望日')+':'+this.formatDate(this.receiveDate));
        }
        if (this.enableReceiveTime) {
          modalSubTitle.push(this._loc.t('お届け希望時間')+':'+this.receiveTime);
        }
        if (this.selectableSms && this.deliveryNotificationType == "sms") {
          modalSubTitle.push(this._loc.t('通知先')+':'+this.deliverySms);
        }
        if (this.selectableEmail && this.deliveryNotificationType == "email") {
          modalSubTitle.push(this._loc.t('通知先')+':'+this.deliveryEmail);
        }
        modalSubTitle.push(this._loc.t('メールアドレス')+':'+this.deliveryEmail);
        modalSubTitle.push(this._loc.t('電話番号')+':'+this.deliverySms);
        modalSubTitle.push(this._loc.t('お名前')+':'+this.name);
        modalSubTitle.push(this._loc.t('郵便番号')+':'+this.postalCode);
        modalSubTitle.push(this._loc.t('住所')+':'+this.address);
      }
      this.requiredMenuList.forEach(r_menus => {
        modalSubTitle.push(r_menus.required_name+':'+r_menus.selected_menu.title);
      })

      if (this.relationCode) {
        modalSubTitle.push(this._loc.t('アプリ会員ID')+':'+this.relationCode);
      }
      if (this.isShowPaymentArea && this.totalAmount > 0) {
        this.paymentModules.filter(module => {
          if (module.type === this.paymentMethod) {
            return modalSubTitle.push(this._loc.t('支払い方法')+':'+module.display_button);
          }
        })
      }
      if (this.note && this.note.length > 0) {

        modalSubTitle.push(this._loc.t('備考')+':'+this.note);
      }
      modalSubTitle.push(this._loc.t('合計金額')+':¥'+newPrice);
      var title = this._loc.t('こちらの内容でお支払いします');
      if (this.paymentMethod == 'nopayment') {
        title = this._loc.t('こちらの内容で承ります');
      }
      const modal = this.modalCtrl.create(ConfirmOrderModalComponent, { title: title, subTitles: modalSubTitle, bottomOkCancel:true }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.onDidDismiss(data => {
          if (data) {
              let eid = localStorage.getItem('employee_id');
              if (!eid) eid = "1";
              if (!eid) {
                let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('サーバーへの接続に問題が発生しています。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                this.osentFlag = false;
                modal.present();
                return;
              }
              let ojson = {
                employee_id: eid,
                orders: [],
                uiid: Config.uiid
              };
              for (var i = 0; i < this.menuArray.length; i++) {
                if (this.menuArray[i].quantity > 0) {
                  ojson.orders.push({
                    remarks: "OkageGo",
                    quantity: this.menuArray[i].quantity,
                    table_id: Config.table_id,
                    origin_quantity: this.menuArray[i].quantity,
                    store_id: localStorage.getItem("store_id"),
                    visitor_id: null,
                    especial_price: this.menuArray[i].price,
                    original_especial_price: this.menuArray[i].price,
                    include_tax_price: this.menuArray[i].notax_price,
                    menu: {
                      menu_id: this.menuArray[i].id
                    },
                    menu_id: this.menuArray[i].id
                  });

                  if (this.menuArray[i].sub) {
                    this.menuArray[i].sub.forEach(esub => {
                      if (esub.quantity > 0) {
                        ojson.orders.push({
                          remarks: "OkageGo",
                          quantity: esub.quantity,
                          parent_menu_id: esub.parent,
                          table_id: Config.table_id,
                          origin_quantity: esub.quantity,
                          especial_price: esub.price,
                          original_especial_price: esub.price,
                          include_tax_price: esub.notax_price,
                          store_id: localStorage.getItem("store_id"),
                          visitor_id: null,
                          menu: {
                            menu_id: esub.id
                          },
                          menu_id: esub.id
                        });
                      }
                    });
                  }
                }
              }

              // insert visitor
              // insert order
              // commit order
              this.loading = this.loadingCtrl.create();
              this.loading.present();

              // ReceiveTimeText (指定の場合はhour, minを対応。指定しない場合は現在の時間)
              let d = new Date();
              if (this.enableReceiveTime) d.setHours(parseInt(localStorage.getItem("hour"), 0), parseInt(localStorage.getItem("min"), 0), 0);
              let timeText = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();

              let custom = localStorage.getItem("custom");
              let notes = localStorage.getItem("note");
              if (!isTakeoutMethod) {
                notes = `名前:${this.name}\n郵便番号:${this.postalCode}\n住所:${this.address}\n備考:${localStorage.getItem("note")}`;
              }
              this._apiService.insertVisitor(timeText, notes, localStorage.getItem("email"), localStorage.getItem("sms"), localStorage.getItem("notificationType"), custom, isTakeoutMethod, localStorage.getItem("guestId"), localStorage.getItem("guestDescription"), localStorage.getItem("menubook_id")).subscribe(
                (result) => {
                  if (parseInt(result.status, 0) == 1000) {
                    let visitor_id = result.result;
                    for (var i = 0; i < ojson.orders.length; i++) {
                      ojson.orders[i].visitor_id = visitor_id;
                    }
                    ojson.orders = this.makeOrderList(visitor_id);
                    this._apiService.order(ojson).subscribe(
                      (result) => {
                        console.log(result);
                        if (parseInt(result.status, 0) == 1000) {
                          let order_no = result.order_no;
                          let memberID = localStorage.getItem("MemberID");
                          this._apiService.getPaymentRequest({ "MemberID": memberID, "visitor_id": visitor_id, "store_id": localStorage.getItem("store_id"), "order_no": order_no, "uiid": Config.uiid, "version": "2.5.1", "payment_type": localStorage.getItem("paymentType") }).subscribe(
                            (result) => {
                              if (!result.status || parseInt(result.status, 0) !== 1000) {
                                this.loading.dismiss();
                                let message = (result.error_message) ? result.error_message : this._loc.t("エラーが発生しました");

                                let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('エラー'), subTitle: message, bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                                modal.present();
                              }
                              else if (result.type && result.type == "paygent") {
                                // paygent
                                localStorage.setItem("visitor_id", visitor_id);
                                this.paygentpayment = {
                                  endpoint: result.endpoint,
                                  request: result.request
                                };
                                setTimeout(function () {
                                  console.log(this.paygentForm);
                                  this.paygentForm.paygentpayment = this.paygentpayment;
                                  setTimeout(function () {
                                    this.loading.dismiss();
                                    this.paygentForm.submit();
                                  }.bind(this), 300);
                                }.bind(this), 300);
                              }
                              else if (result.type && result.type=="okagepay") {
                                // okagepay
                                localStorage.setItem("visitor_id", visitor_id);
                                this.okagepaypayment = {
                                  endpoint:result.endpoint,
                                  request:result.request
                                };
                                console.log(this.okagepaypayment);

                                setTimeout(function(){
                                  console.log(this.okagepayForm);
                                  this.okagepayForm.okagepaypayment = this.okagepaypayment;
                                  setTimeout(function(){
                                    this.loading.dismiss();
                                    this.okagepayForm.submit();
                                  }.bind(this), 300);
                                }.bind(this), 300);
                              }
                              else if (result.type && result.type=="nopayment") {
                                // 後払いの場合はクレジット入力画面に遷移せずそのままokagegoに戻る
                                localStorage.setItem("visitor_id", visitor_id);
                                window.location.href = result.redirect_url;
                                return;
                              } else {
                                // gmo
                                localStorage.setItem("visitor_id", result.request.ClientField3);
                                this.gmopayment = result.request;
                                this.gmopayment.endpoint = result.endpoint;
                                this.shopId = result.request.ShopID;
                                this.gmolink = this._apiService.getGmolink();

                                setTimeout(function () {
                                  this.paymentForm.gmopayment = this.gmopayment;
                                  setTimeout(function () {
                                    this.loading.dismiss();
                                    this.paymentForm.submit();
                                  }.bind(this), 300);
                                }.bind(this), 300);
                              }
                            }
                          );
                        } else {
                          this.loading.dismiss();
                          let error_message = (result.error_message)
                            ? result.error_message
                            : this._loc.t("エラーが発生しました。");

                          let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: error_message, bottomButton: 'OK', redirect: result.need_reload }, { showBackdrop: false, enableBackdropDismiss: false });
                          modal.present();
                        }
                      }
                    );

                  }
                  else {
                    this.loading.dismiss();
                    if (result.error_message) {
                      let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: result.error_message, bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                      modal.present();
                    } else {
                      let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('サーバーへの接続に問題が発生しています。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                      modal.present();
                    }
                  }
                }, (error) => {
                  let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('サーバーへの接続に問題が発生しています。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                  modal.present();
                  this.loading.dismiss();
                }
              );
          }
      });
      modal.present();
    }
  }

  clickToReservePayment() {
    if (this.totalAmount == 0) {
      this.paymentMethod = 'nopayment';
    }
    this.saveMobileOrderOption()
    if (!this.validateTenkaiMenu(true)) {
      return;
    }

    if (this.config.build_as_takeout) {
      let isTakeoutMethod = (this.receiveMethod === 'takeout');
      if (isTakeoutMethod && !this.validateTakeoutInput(true)) {
        return;
      }
      if (isTakeoutMethod && !this.validateTakeoutRange()) {
        return;
      }
      if(!isTakeoutMethod && !this.validateDeliveryInput(true)) {
        return;
      }
      var newPrice;
      newPrice = String(this.totalAmount).split('.');
      newPrice[0] = newPrice[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      newPrice.join('.');

      var modalSubTitle = [];

      if (isTakeoutMethod) {
        if (this.enableReceiveDate) {
          modalSubTitle.push(this._loc.t('受け取り日')+':'+this.formatDate(this.receiveDate));
        }
        if (this.enableReceiveTime) {
          modalSubTitle.push(this._loc.t('受け取り時間')+':'+this.receiveTime);
        }
        if (this.reservedGuestName) {
          modalSubTitle.push(this._loc.t('お名前')+':'+this.reservedGuestName);
        }
        if (this.selectableSms && this.notificationType == "sms") {
          modalSubTitle.push(this._loc.t('通知先')+':'+this.sms);
        }
        if (this.selectableEmail && this.notificationType == "email") {
          modalSubTitle.push(this._loc.t('通知先')+':'+this.email);
        }
      } else {
        if (this.enableReceiveDate) {
          modalSubTitle.push(this._loc.t('お届け希望日')+':'+this.formatDate(this.receiveDate));
        }
        if (this.enableReceiveTime) {
          modalSubTitle.push(this._loc.t('お届け希望時間')+':'+this.receiveTime);
        }
        if (this.selectableSms && this.deliveryNotificationType == "sms") {
          modalSubTitle.push(this._loc.t('通知先')+':'+this.deliverySms);
        }
        if (this.selectableEmail && this.deliveryNotificationType == "email") {
          modalSubTitle.push(this._loc.t('通知先')+':'+this.deliveryEmail);
        }
        modalSubTitle.push(this._loc.t('メールアドレス')+':'+this.deliveryEmail);
        modalSubTitle.push(this._loc.t('電話番号')+':'+this.deliverySms);
        modalSubTitle.push(this._loc.t('お名前')+':'+this.name);
        modalSubTitle.push(this._loc.t('郵便番号')+':'+this.postalCode);
        modalSubTitle.push(this._loc.t('住所')+':'+this.address);
      }
      this.requiredMenuList.forEach(r_menus => {
        modalSubTitle.push(r_menus.required_name+':'+r_menus.selected_menu.title);
      })

      if (this.relationCode) {
        modalSubTitle.push(this._loc.t('アプリ会員ID')+':'+this.relationCode);
      }
      if (this.isShowPaymentArea && this.totalAmount > 0) {
        this.paymentModules.filter(module => {
          if (module.type === this.paymentMethod) {
            return modalSubTitle.push(this._loc.t('支払い方法')+':'+module.display_button);
          }
        })
      }
      if (this.note && this.note.length > 0) {

        modalSubTitle.push(this._loc.t('備考')+':'+this.note);
      }
      modalSubTitle.push(this._loc.t('合計金額')+':¥'+newPrice);
      var title = this._loc.t('こちらの内容でお支払いします');
      if (this.paymentMethod == 'nopayment') {
        title = this._loc.t('こちらの内容で承ります');
      }

      const modal = this.modalCtrl.create(ConfirmOrderModalComponent, { title: title, subTitles: modalSubTitle, bottomOkCancel:true }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.onDidDismiss(sendOkBtn => {
          if (sendOkBtn) {
              // 以前に同じ商品を注文しているかチェック
              let targetIds = this.getCheckTargetIds(this.orderList);
              if (targetIds.length > 0) {
                this._apiService.getReservedHistory(this.email, targetIds).subscribe(result => {
                  if (parseInt(result.status, 0) == 1000) {
                    let orderdDate = result.result;
                    if (orderdDate != '') {
                      // 重複あり→確認モーダル
                      let duplicateCheckModal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('ご注文内容の確認'), subTitles: ['こちらの商品は' + orderdDate + 'に注文されていますが、注文しますか'], bottomOkCancel: true }, { showBackdrop: false, enableBackdropDismiss: false });
                      duplicateCheckModal.onDidDismiss(duplicateOkBtn => {
                        if (duplicateOkBtn) {
                          // モーダルOK→注文送信
                          this.sendOrder(isTakeoutMethod);
                        } else {
                          return;
                        }
                      });
                      duplicateCheckModal.present();
                    } else {
                      // 重複なしなのでそのまま注文送信
                      this.sendOrder(isTakeoutMethod);
                    }
                  }
                });
                return;
              }
              // 重複チェック対象商品を選択していないのでそのまま注文送信
              this.sendOrder(isTakeoutMethod);
          }
      });
      modal.present();
    }
  }

  // 注文送信
  sendOrder(isTakeoutMethod) {
    let eid = localStorage.getItem('employee_id');
    if (!eid) eid = "1";
    if (!eid) {
      let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('サーバーへの接続に問題が発生しています。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
      this.osentFlag = false;
      modal.present();
      return;
    }
    let ojson = {
      employee_id: eid,
      orders: [],
      uiid: Config.uiid
    };

    // insert visitor
    // insert order
    // commit order
    this.loading = this.loadingCtrl.create();
    this.loading.present();

    // ReceiveTimeText (指定の場合はhour, minを対応。指定しない場合は現在の時間)
    let d = new Date(this.receiveDate);
    d.setHours(Number(this.receiveTime.substr(0,2)));
    d.setMinutes(Number(this.receiveTime.substr(3,2)));
    let timeText = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();

    let custom = localStorage.getItem("custom");
    let notes = localStorage.getItem("note");
    if (!isTakeoutMethod) {
      notes = `名前:${this.name}\n郵便番号:${this.postalCode}\n住所:${this.address}\n備考:${localStorage.getItem("note")}`;
    }
    this._apiService.insertReservedVisitor(timeText, notes, localStorage.getItem("email"), localStorage.getItem("sms"), localStorage.getItem("notificationType"), custom, isTakeoutMethod, localStorage.getItem("guestId"), localStorage.getItem("guestName"), localStorage.getItem("guestDescription"),this.reserved_settings).subscribe(
      (result) => {
        if (parseInt(result.status, 0) == 1000) {
          let visitor_id = result.result;
          for (var i = 0; i < ojson.orders.length; i++) {
            ojson.orders[i].visitor_id = visitor_id;
          }
          ojson.orders = this.makeOrderList(visitor_id);
          this._apiService.reservedOrder(ojson).subscribe(
            (result) => {
              console.log(result);
              if (parseInt(result.status, 0) == 1000) {
                let order_no = result.order_no;
                let memberID = localStorage.getItem("MemberID");
                this._apiService.getReservedPaymentRequest({ "MemberID": memberID, "visitor_id": visitor_id, "store_id": localStorage.getItem("store_id"), "order_no": order_no, "uiid": Config.uiid, "version": "2.5.1", "payment_type": localStorage.getItem("paymentType"), "reserved" : "1" }).subscribe(
                  (result) => {
                    if (!result.status || parseInt(result.status, 0) !== 1000) {
                      this.loading.dismiss();
                      let message = (result.error_message) ? result.error_message : this._loc.t("エラーが発生しました");

                      let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('エラー'), subTitle: message, bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                      modal.present();
                    } else if (result.type && result.type == "paygent") {
                      // paygent
                      localStorage.setItem("visitor_id", visitor_id);
                      this.paygentpayment = {
                        endpoint: result.endpoint,
                        request: result.request
                      };
                      setTimeout(function () {
                        console.log(this.paygentForm);
                        this.paygentForm.paygentpayment = this.paygentpayment;
                        setTimeout(function () {
                          this.loading.dismiss();
                          this.paygentForm.submit();
                        }.bind(this), 300);
                      }.bind(this), 300);
                    } else if (result.type && result.type=="okagepay") {
                      // okagepay
                      localStorage.setItem("visitor_id", visitor_id);
                      this.okagepaypayment = {
                        endpoint:result.endpoint,
                        request:result.request
                      };
                      console.log(this.okagepaypayment);

                      setTimeout(function(){
                        console.log(this.okagepayForm);
                        this.okagepayForm.okagepaypayment = this.okagepaypayment;
                        setTimeout(function(){
                          this.loading.dismiss();
                          this.okagepayForm.submit();
                        }.bind(this), 300);
                      }.bind(this), 300);
                    } else if (result.type && result.type=="nopayment") {
                      // 後払いの場合はクレジット入力画面に遷移せずそのままokagegoに戻る
                      localStorage.setItem("visitor_id", visitor_id);
                      window.location.href = result.redirect_url;
                      return;
                    } else {
                      // gmo
                      localStorage.setItem("visitor_id", result.request.ClientField3);
                      this.gmopayment = result.request;
                      this.gmopayment.endpoint = result.endpoint;
                      this.shopId = result.request.ShopID;
                      this.gmolink = this._apiService.getGmolink();

                      setTimeout(function () {
                        this.paymentForm.gmopayment = this.gmopayment;
                        setTimeout(function () {
                          this.loading.dismiss();
                          this.paymentForm.submit();
                        }.bind(this), 300);
                      }.bind(this), 300);
                    }
                  }
                );
              } else {
                this.loading.dismiss();
                let error_message = (result.error_message) ? result.error_message : this._loc.t("エラーが発生しました。");

                let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: error_message, bottomButton: 'OK', redirect: result.need_reload }, { showBackdrop: false, enableBackdropDismiss: false });
                modal.present();
              }
            }
          );
        } else {
          this.loading.dismiss();
          if (result.error_message) {
            let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: result.error_message, bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
            modal.present();
          } else {
            let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('サーバーへの接続に問題が発生しています。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
            modal.present();
          }
        }
      }, (error) => {
        let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('サーバーへの接続に問題が発生しています。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
        modal.present();
        this.loading.dismiss();
      }
    );
  }

  makeOrderList(visitor_id = 0) {
    if (visitor_id < 1) visitor_id = parseInt(localStorage.getItem("visitor_id"), 0);
    var newOrderList = [];
    for (let i = 0; i < this.orderList.length; i++) {
      newOrderList.push(
        {
          especial_price: this.orderList[i].price,
          include_tax_price: this.orderList[i].notax_price,
          menu: {
              menu_id: this.orderList[i].menu_id,
          },
          menu_id: this.orderList[i].menu_id,
          origin_quantity: this.orderList[i].origin_quantity,
          original_especial_price: this.orderList[i].original_especial_price,
          quantity: this.orderList[i].quantity,
          remarks: this.orderList[i].remarks,
          store_id: localStorage.getItem("store_id"),
          table_id: Config.table_id,
          visitor_id: visitor_id,
          seq_no: i
        }
      );
      for (let j = 0; j < this.orderList[i].sub.length; j++) {
        //if (this.orderList[i].sub[j].quantity > 0) { // 数量0のサブメニューはオーダーに挿入しない場合
          newOrderList.push(
            {
              especial_price: this.orderList[i].sub[j].price,
              include_tax_price: this.orderList[i].sub[j].notax_price,
              menu: {
                  menu_id: this.orderList[i].sub[j].menu_id,
              },
              menu_id: this.orderList[i].sub[j].menu_id,
              origin_quantity: this.orderList[i].origin_quantity * this.orderList[i].sub[j].origin_quantity,
              original_especial_price: this.orderList[i].sub[j].original_especial_price,
              parent_menu_id: this.orderList[i].menu_id,
              quantity: this.orderList[i].quantity * this.orderList[i].sub[j].quantity,
              remarks: this.orderList[i].sub[j].remarks,
              store_id: localStorage.getItem("store_id"),
              table_id: Config.table_id,
              visitor_id: visitor_id,
              seq_no: i
            }
          );
        //}
      }
    }
    this.requiredMenuList.forEach(r_menus => {
      if (r_menus.selected_menu) {
        newOrderList.push({
          especial_price: r_menus.selected_menu.price,
          include_tax_price: r_menus.selected_menu.notax_price,
          menu: {
              menu_id: r_menus.selected_menu.id,
          },
          menu_id: r_menus.selected_menu.id,
          origin_quantity: 1,
          original_especial_price: r_menus.selected_menu.price,
          quantity: 1,
          remarks: "OkageGo",
          store_id: localStorage.getItem("store_id"),
          table_id: Config.table_id,
          visitor_id: visitor_id,
          seq_no: newOrderList.length+1
        });
      }
    });
    if (this.deliveryChargeStatus === 1) {
      newOrderList.push({
        especial_price: this.deliveryCharge.charge_menu.price,
        include_tax_price: this.deliveryCharge.charge_menu.notax_price,
        menu: {
            menu_id: this.deliveryCharge.charge_menu.id,
        },
        menu_id: this.deliveryCharge.charge_menu.id,
        origin_quantity: 1,
        original_especial_price: this.deliveryCharge.charge_menu.price,
        quantity: 1,
        remarks: "OkageGo",
        store_id: localStorage.getItem("store_id"),
        table_id: Config.table_id,
        visitor_id: visitor_id,
        seq_no: newOrderList.length+1
      });
    }
    return newOrderList;
  }

  // 重複チェック対象商品を注文しているかチェック
  getCheckTargetIds(orderList) {
    let duplicateIds = [];
    if (this.duplicateOrderCheck.length > 0) {
      console.log(this.duplicateOrderCheck);
       // 親メニューのみチェック
       orderList.forEach(order => {
        if (order.quantity > 0) {
          JSON.parse(this.duplicateOrderCheck).check_menu_ids.forEach(checkId => {
            if (order.menu_id == checkId) {
              duplicateIds.push(order.menu_id);
            }
          })
        }
      });
    }
    return duplicateIds;
  }

  changeRequiredMenu(index, requiredMenu) {
    this.requiredMenuList[index].selected_menu = requiredMenu;
    this.calculateTotalAmount();
  }
  selectReceiveDate(r_date) {
    this.receiveTime = "";
    this.reserved_datetime = "";
    this.receiveTimes = r_date.time;
    this.calculateTotalAmount();
  }
  selectReserveTime(r_time) {
    this.calculateTotalAmount();
  }
  formatDate(dt) {
    var newDt = new Date(dt);
    var y = newDt.getFullYear();
    var m = ('00' + (newDt.getMonth()+1)).slice(-2);
    var d = ('00' + newDt.getDate()).slice(-2);
    return (y + '-' + m + '-' + d);
  }
}



// WEBPACK FOOTER //
// ./src/pages/send-order/send-order.ts